












export default {
  name: 'BillIcon'
}
